import React, { useState, useEffect } from 'react';

import BiaButton from '~/ui/3dbiaUI/BiaButton/BiaButton';
import LoginWrapper from '~/components/LoginWrapper';
import OrgNames from './OrgNames';
import ProviderNames from './ProviderNames';
import Roles from './Roles';
import { onlyUnique, getIndependantProviderRoles } from './utils';
import type { 
  RoleSelectionProps, 
  ActiveState, 
  OrganizationRole, 


} from '~/types/roles';
import './RegistrationProcess.css'


const RoleSelection: React.FC<RoleSelectionProps> = ({
  user,
  onRoleSelected,
  onLogout,

}) => {

  const [pageTitle, setPageTitle] = useState<string>('Select role');
  const [provider, setProvider] = useState<string | undefined>();
  const [providers, setProviders] = useState<string[]>([]);
  const [organization, setOrganization] = useState<string | undefined>();
  const [selectedRole, setSelectedRole] = useState<OrganizationRole | undefined>();
  const [roles, setRoles] = useState<(OrganizationRole)[]>([]);

  useEffect(() => {
    if (user) {
      handleCurrentUser();
    } else {
    //   historyObject.push('/');
    }
  }, [user]);

  const handleCurrentUser = (): void => {
    console.log('handleCurrentUser', user);
    if (!user) return;

    if (
      user.userOrganizationRoles.length === 1 &&
      user.userProviderRoles.length === 0
    ) {
    //   historyObject.push(
    //     `/organizations/${user.userOrganizationRoles[0].organization_id}`,
    //   );
      onRoleSelected(user.userOrganizationRoles[0]);
    }
    // If user has no organization roles and one provider roles
    else if (
      !user.userOrganizationRoles.length &&
      user.userProviderRoles.length === 1
    ) {
    //   historyObject.push(
    //     `/providers/${user.userProviderRoles[0].provider_id}`,
    //   );
      onRoleSelected(user.userProviderRoles[0]);
    }
    // If user has 1 organization role and 1 provider role
    else if (
      user.userProviderRoles.length === 1 &&
      user.userOrganizationRoles.length === 1
    ) {
      // If org and provider are connected
      if (
        user.userProviderRoles[0].provider_id ===
        user.userOrganizationRoles[0].provider_id
      ) {
        const orgId = user.userOrganizationRoles[0].organization_id;
        // historyObject.push({
        //   pathname: `/providers/${user.userProviderRoles[0].provider_id}/${orgId}`,
        //   state: {
        //     organization_id: user.userOrganizationRoles[0].organization_id,
        //   },
        // });
        onRoleSelected(user.userOrganizationRoles[0]);
      }
    } else {
      setPageTitle(
        `Welcome 
        ${user.first_name ? user.first_name : ''}  
        ${user.last_name ? user.last_name : ''}`,
      );
    }
  };

  const handleGo = (): void => {
    if (!selectedRole) return;

    if ('provider_id' in selectedRole && selectedRole.provider_id) {
    //   historyObject.push({
    //     pathname: `/providers/${selectedRole.provider_id}/${selectedRole.organization_id}`,
    //     state: {
    //       organization_id: selectedRole.organization_id,
    //       role: selectedRole.role_type_id,
    //     },
    //   });
      onRoleSelected(selectedRole);
    } else {
    //   historyObject.push({
    //     pathname: `/organizations/${selectedRole.organization_id}`,
    //     role: selectedRole.role_name,
    //   });
      onRoleSelected(selectedRole);
    }
  };

  const handleOrgClick = (orgName: string): void => {
    if (!user) return;
    
    console.log('orgName', orgName);
    if (organization !== orgName) {
      setOrganization(orgName);
      setSelectedRole(undefined);
      console.log('user', user);
      
      const orgRoles = user.userOrganizationRoles.filter(
        (role: any) => role.org_name === orgName,
      );
      console.log('orgRoles', orgRoles);
      
      if (!user.userProviderRoles.length) setRoles(orgRoles);

      if (orgRoles.length === 1) {
        setSelectedRole(orgRoles[0]);
        setProviders([]);
        setRoles(orgRoles);
      } else {
        setSelectedRole(undefined);
        const providersNames = orgRoles.map((orgRole: any) =>
          orgRole.provider_name ? orgRole.provider_name : 'None',
        );
        const uniqueProvNames = providersNames.filter(onlyUnique);
        const inHouseProviderRoles = getIndependantProviderRoles(user);
        const providerNames: string[] = [];

        // If there is no organization roles and only in house provider roles
        if (orgName === 'None') {
          inHouseProviderRoles.forEach(role => {
            if (!providerNames.includes(role.provider_name!))
              providerNames.push(role.provider_name!);
          });
          if (providerNames.length === 1)
            handleProviderClick(providerNames[0], orgName);
          else setProviders(providerNames);
        } else {
          if (uniqueProvNames.length === 1)
            handleProviderClick(uniqueProvNames[0], orgName);
          setProviders(uniqueProvNames);
        }
      }
    }
  };

  const handleProviderClick = (provider_name: string, orgName?: string): void => {
    if (!user) return;
    
    console.log('provider_name', provider_name, orgName);
    setProvider(provider_name);
    setRoles([]);
    setSelectedRole(undefined);
    
    let roles: (OrganizationRole)[];
    
    if (provider_name === 'None') {
      roles = user.userOrganizationRoles.filter(
        (orgRole: any) => orgRole.provider_id === 0 && orgRole.org_name === orgName,
      );

      if (roles.length === 1) {
        setSelectedRole(roles[0]);
      }
    } else {
      if (organization === 'None') {
        roles = user.userProviderRoles.filter(
          (provRole: any) => provRole.provider_name === provider_name,
        );
      } else {
        roles = user.userOrganizationRoles.filter(
          (orgRole: any) =>
            orgRole.provider_name === provider_name &&
            orgRole.org_name === orgName,
        );
      }

      if (roles.length === 1) {
        setSelectedRole(roles[0]);
      }
    }

    if (roles.length === 1) {
      setSelectedRole(roles[0]);
    }
    if (roles.length >= 1) {
      setRoles(roles);
    }
  };

  const handleRoleClick = (role: OrganizationRole): void => {
    if (!user) return;

    console.log('role', role);
    setSelectedRole(role);
  };

  if (!user) {
    return null;
  }
  // console.log(roles);
  // console.log({ selectedRole });
  return (
    // <LoginWrapper pageTitle={pageTitle}>
      <div className="justify-content-center no-gutters bg-white m-2 mx-5">
        <div className="mx-5">
          <div className="row selectRow position-relative my-4">
            <div className="col-4 p-3 border-right-secondary">Organization</div>
            <div className="col-8">
              <OrgNames 
                user={user}
                organization={organization}
                onOrgClick={handleOrgClick}
              />
            </div>
          </div>
          <div className="row selectRow position-relative my-4">
            <div className="col-4 p-3 border-right-secondary">Provider</div>
            <div className="col-8">
              <ProviderNames 
                providers={providers}
                provider={provider}
                organization={organization}
                onProviderClick={handleProviderClick}
              />
            </div>
          </div>
          <div className="row selectRow position-relative">
            <div className="col-4 p-3 border-right-secondary">Role</div>
            <div className="col-8">
              <Roles 
                roles={roles}
                selectedRole={selectedRole}
                onRoleClick={handleRoleClick}
              />
            </div>
          </div>

          <div className="text-center buttons">
            <BiaButton
              onClick={handleGo}
              className={`bg-success color-white bold mt-5 ${
                !selectedRole ? 'disabled' : ''
              }`}
            >
              Go
            </BiaButton>
            <div className="d-flex justify-content-center fullWidth">
              {user && user.userSystemRoles.length ? (
                <div
                  id="adminButton"
                  className="bgSecondary mt-3 p-0"
                  onClick={() => {

                    onRoleSelected(user.userSystemRoles[0]);
                  }}
                >
                  Admin
                </div>
              ) : null}
              <div
                onClick={() => {
                  onLogout();

                }}
                className="mt-2 signOutButton"
              >
                Sign out
              </div>
            </div>
          </div>
        </div>
      </div>
    // {/* </LoginWrapper> */}
  );
};

export default RoleSelection;
